import { render, staticRenderFns } from "./ProductionExpirationDateCellRenderer.vue?vue&type=template&id=8ccd188e&scoped=true&lang=pug&"
import script from "./ProductionExpirationDateCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./ProductionExpirationDateCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionExpirationDateCellRenderer.vue?vue&type=style&index=0&id=8ccd188e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccd188e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
